import axios from "axios";


export default function getAPIClient(BX24) {
    let headers = {}
    // Режим «зайти как портал» из админки: вместо BX24-заголовков — один JWT,
    // бэкенд сам подставит сохранённый токен портала
    const impersonationToken = sessionStorage.getItem('impersonation_token')
    if (impersonationToken) {
        headers = {
            'X-Impersonation-Token': impersonationToken,
            'accept': 'application/json'
        }
    } else if (BX24 !== undefined) {
        const bx24Params = BX24.getAllParams()
        headers = {
            "X-ACCESS-TOKEN": bx24Params.AUTH_ID,
            "X-ACCESS-TOKEN-EXPIRES": bx24Params.AUTH_EXPIRES,
            "X-REFRESH-TOKEN": bx24Params.REFRESH_ID,
            "X-PORTAL-MEMBER-ID": bx24Params.MEMBER_ID,
            "X-PORTAL-DOMAIN": bx24Params.DOMAIN,
            'accept': 'application/json'
        }
    }

    const instance = axios.create({
        baseURL: `${process.env.REACT_APP__API_URL}`,
        headers: headers
    })

    if (impersonationToken === null && BX24 !== undefined) {
        instance.interceptors.response.use(
            response => response,
            async error => {
                const originalRequest = error.config
                if (error.response?.status === 401 && !originalRequest._retried) {
                    originalRequest._retried = true
                    try {
                        const newParams = await new Promise((resolve, reject) => {
                            BX24.refreshAuth(params => params ? resolve(params) : reject())
                        })
                        instance.defaults.headers['X-ACCESS-TOKEN'] = newParams.AUTH_ID
                        instance.defaults.headers['X-REFRESH-TOKEN'] = newParams.REFRESH_ID
                        instance.defaults.headers['X-ACCESS-TOKEN-EXPIRES'] = newParams.AUTH_EXPIRES
                        originalRequest.headers['X-ACCESS-TOKEN'] = newParams.AUTH_ID
                        originalRequest.headers['X-REFRESH-TOKEN'] = newParams.REFRESH_ID
                        originalRequest.headers['X-ACCESS-TOKEN-EXPIRES'] = newParams.AUTH_EXPIRES
                        return instance(originalRequest)
                    } catch {
                        return Promise.reject(error)
                    }
                }
                return Promise.reject(error)
            }
        )
    }

    return instance
}
